var exports = {
  "kL": "xdde3148b--cc3c59--container",
  "DD": "xdde3148b--cc3c59--title",
  "h_": "xdde3148b--cc3c59--description",
  "io": "xdde3148b--cc3c59--open-village-logo",
  "nf": "xdde3148b--cc3c59--link",
};

module.exports = exports;
